<template>
  <div>
    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Modalidade" prop="modalidade" :rules="[$requiredChange]" key="modalidade">
              <el-select v-model="dados.modalidade">
                <el-option label="CRECHE" value="creche"></el-option>
                <el-option label="PRÉ-ESCOLA" value="pre"></el-option>
                <el-option label="FUNDAMENTAL" value="fundamental"></el-option>
                <el-option label="EJA" value="eja"></el-option>
                <el-option label="INTEGRAL" value="integral"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4" :md="4">
            <el-form-item label="Idade mín. (anos)" prop="idade_min" key="idade_min">
              <el-input v-model="dados.idade_min" maxlength="3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4" :md="4">
            <el-form-item label="Idade máx. (anos)" prop="idade_max" key="idade_max">
              <el-input v-model="dados.idade_max" maxlength="3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4" :md="4">
            <el-form-item label="Ativo" prop="ativo" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option :key="true" label="SIM" :value="true"></el-option>
                <el-option :key="false" label="NÃO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="% mínimo Agric. Familiar" prop="pct_af_minimo" key="pct_af_minimo">
              <el-input v-model="dados.pct_af_minimo" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <c-panel title="Recomendações nutricionais (por refeição/dia)" titleIcon="fas fa-balance-scale">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item label="kcal recomendado" prop="kcal_recomendado" key="kcal_recomendado">
                <el-input v-model="dados.kcal_recomendado" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item label="Proteína (g)" prop="proteina_g" key="proteina_g">
                <el-input v-model="dados.proteina_g" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item label="Carboidrato (g)" prop="carboidrato_g" key="carboidrato_g">
                <el-input v-model="dados.carboidrato_g" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item label="Lipídio (g)" prop="lipidio_g" key="lipidio_g">
                <el-input v-model="dados.lipidio_g" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item label="Fibra (g)" prop="fibra_g" key="fibra_g">
                <el-input v-model="dados.fibra_g" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item label="Sódio máx. (mg)" prop="sodio_mg_max" key="sodio_mg_max">
                <el-input v-model="dados.sodio_mg_max" maxlength="12"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item label="Per capita (g)" prop="per_capita_g" key="per_capita_g">
                <el-input v-model="dados.per_capita_g" maxlength="12"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </c-panel>

        <c-panel title="Vigência" titleIcon="far fa-calendar">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="8" :md="8">
              <el-form-item label="Início" prop="vigencia_inicio" key="vigencia_inicio">
                <el-date-picker v-model="dados.vigencia_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <el-form-item label="Fim (opcional)" prop="vigencia_fim" key="vigencia_fim">
                <el-date-picker v-model="dados.vigencia_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </c-panel>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-pnae" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    edit: false,
    dados: {
      id: '',
      modalidade: '',
      idade_min: '',
      idade_max: '',
      kcal_recomendado: '',
      proteina_g: '',
      carboidrato_g: '',
      lipidio_g: '',
      fibra_g: '',
      sodio_mg_max: '',
      per_capita_g: '',
      pct_af_minimo: '30.00',
      vigencia_inicio: '',
      vigencia_fim: '',
      ativo: true
    }
  }),
  methods: {
    getById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/pnae-parametro/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => { this.dados = JSON.parse(JSON.stringify(response.data)) })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    onSubmit () {
      document.getElementById("btn-pnae").focus()
      this.$refs.dados.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        const url = this.edit
          ? `${this.$store.state.config.baseUrlApi}/api/merenda/pnae-parametro/update/${this.dados.id}`
          : `${this.$store.state.config.baseUrlApi}/api/merenda/pnae-parametro/store`
        this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
          .then(response => {
            window.eventBus.$emit('loading', false)
            if (response.data && response.data.erro) {
              const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
              return window.eventBus.$emit('alert', { msg, type: 'warning' })
            }
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.$emit('onSubmitPnae')
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getById(value)
          this.edit = true
        }
      }
    }
  }
}
</script>
